/**
 * Copyright © 2026 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

export const DAI_ZERO_REVIEW_MUTATION_RESULT_FIELDS = gql`
  fragment DAIZeroReviewMutationResultFields on DAIZeroReviewMutationResult {
    success
    operationId
    updatedCount
    queued
  }
`
